import Blockly from "blockly";

const componentStyles = { workspaceBackgroundColour: "rgba(255,255,255,0.2)" };
export const theme = Blockly.Theme.defineTheme("inexus-courses", {
  base: Blockly.Themes.Zelos,
  componentStyles: componentStyles,
  fontStyle: { family: "MPLUSRounded1c-Bold", weight: "normal", size: 16 },
  startHats: true,
});
